var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.364 8.5a1 1 0 01-1.732 0L.736 1.75a1 1 0 01.867-1.5h7.79a1 1 0 01.867 1.5L6.364 8.5z"
  })));
}
export default SvgTriangleDown;